<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      botToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    botToken: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const telegramChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            channel: {
              type: 'telegram',
              bot_token: this.botToken,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: telegramChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.DESC')"
    />
    <section
      class="mb-6 max-w-4xl rounded-xl border border-n-weak bg-n-alpha-1 p-5"
    >
      <h3 class="text-sm font-semibold text-n-slate-12">
        {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.TITLE') }}
      </h3>
      <div class="mt-3 grid gap-3 md:grid-cols-2">
        <article class="rounded-lg border border-n-weak bg-n-solid-1 p-4">
          <p class="text-sm font-medium text-n-slate-12">
            {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.DIRECT_TITLE') }}
          </p>
          <p class="mt-1 text-xs leading-5 text-n-slate-10">
            {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.DIRECT_DESC') }}
          </p>
        </article>
        <article class="rounded-lg border border-n-blue-7 bg-n-blue-2 p-4">
          <div class="flex items-center justify-between gap-2">
            <p class="text-sm font-medium text-n-slate-12">
              {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.PROFILE_TITLE') }}
            </p>
            <span
              class="rounded-full bg-n-blue-4 px-2 py-0.5 text-xs font-medium text-n-blue-11"
            >
              {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.PROFILE_BADGE') }}
            </span>
          </div>
          <p class="mt-1 text-xs leading-5 text-n-slate-10">
            {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.PROFILE_DESC') }}
          </p>
        </article>
      </div>
      <div class="mt-4 rounded-lg bg-n-solid-2 p-4">
        <p class="text-xs font-semibold text-n-slate-12">
          {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.STEPS_TITLE') }}
        </p>
        <ol
          class="mt-2 list-decimal space-y-1 pl-5 text-xs leading-5 text-n-slate-11"
        >
          <li
            v-for="step in $tm('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.STEPS')"
            :key="step"
          >
            {{ step }}
          </li>
        </ol>
        <p class="mt-3 text-xs leading-5 text-n-amber-11">
          {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.MODES.HISTORY_NOTICE') }}
        </p>
      </div>
    </section>
    <form
      class="flex max-w-4xl flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.botToken.$error }">
          {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.LABEL') }}
          <input
            v-model="botToken"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.PLACEHOLDER')
            "
            @blur="v$.botToken.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.BOT_TOKEN.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.TELEGRAM_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
